import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// Stripe Checkout return page. The payment itself is confirmed by the
// webhook (checkout.session.completed) — this page is purely informational,
// which is why it doesn't poll the API.

export function PaymentSuccessPage() {
  const { t } = useTranslation()
  return (
    <main className="container">
      <h1>{t('payments.success_title')}</h1>
      <p>{t('payments.success_body')}</p>
      <p><Link to="/me/enrollments">{t('payments.go_enrollments')}</Link></p>
    </main>
  )
}
